import { appBus } from '..'

export function nextBackgroundMusic(startPlay = true) {
  appBus.commands.emit('backgroundMusic.next', { startPlay })
}
